import * as moment from 'moment';
import * as _ from 'lodash';
import { IWatrTrip } from '@nkr/models/watr-trip';
import { ITripGroup } from '../types/trip.types';
import { ILineItem } from '../types/line-item.types';
import { getTripPhaseName, getTripPhaseOrder } from '../constants/trip-phases';
import { getTripStatus } from '../constants/trip-status';

export const groupTripsByPhase = (trips: IWatrTrip[], lineItemsMap: Map<number, ILineItem[]>): ITripGroup[] => {
    const groups: ITripGroup[] = [];
    
    trips.forEach(trip => {
        const tripPhase = getTripPhaseName(trip);
        const lineItems = lineItemsMap.get(trip.id) || [];
        
        const startDate = trip.startDate ? moment(trip.startDate) : (trip.tripDate ? moment(trip.tripDate) : moment(trip.createdDateTime));
        const endDate = trip.endDate ? moment(trip.endDate) : startDate;

        groups.push({
            id: trip.id,
            name: tripPhase,
            type: tripPhase,
            startDate: startDate.format('MM/DD/YYYY'),
            endDate: endDate.format('MM/DD/YYYY'),
            status: getTripStatus(trip),
            trip: trip,
            lineItems: lineItems,
            travelRequestId: trip.travelRequestId || 0
        });
    });

    const sortedGroups = _.orderBy(
        groups,
        [
            g => getTripPhaseOrder(g.trip),
            g => moment(g.startDate, 'MM/DD/YYYY'),
            g => {
                const statusOrder = { 'pending': 0, 'in_review': 1, 'approved': 2, 'declined': 3 };
                return statusOrder[g.status as keyof typeof statusOrder] ?? 4;
            } 
        ],
        ['asc', 'asc', 'asc']
    );

    return sortedGroups;
};

export const findFirstPendingTripIndex = (groups: ITripGroup[]): number | null => {
    if (groups.length === 0) return null;
    const index = groups.findIndex(g => g.status === 'pending' || g.status === 'in_review');
    return index !== -1 ? index : null;
};

export const findNextPendingTrip = (groups: ITripGroup[], currentIndex: number): number | null => {
    if (groups.length === 0) return null;
    
    for (let i = currentIndex + 1; i < groups.length; i++) {
        if (groups[i].status === 'pending' || groups[i].status === 'in_review') {
            return i;
        }
    }
    
    for (let i = 0; i < currentIndex; i++) {
        if (groups[i].status === 'pending' || groups[i].status === 'in_review') {
            return i;
        }
    }
    
    return null;
};

